import React from 'react';
import moment from "moment-timezone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import L from "leaflet";
import Map from "../Map";
import MapControls from "../Map/MapControls";
import DayTaskRenderer from "../../pages/Competition/DayTaskRenderer";
import {useSelector} from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2";
import {Stack} from "@mui/material";
import {Util} from  "../../lib/cc-map";
import {useCCI} from "../../lib/cci";
import {Download} from "@mui/icons-material";

const M_TO_FT=3.28084

const DayTaskDetails = ({day}) => {
    const rules = useSelector( state => state.session.eventRules)

    const CCI = useCCI()

    const heightFt=rules.altUnits && rules.altUnits===1;

    if (heightFt && !day.r.m) {
        //height has been set to feet but we have no task details in feet
        day.r.m={
            h:Math.round(day.h * M_TO_FT),
            f:Math.round(day.f * M_TO_FT),
            c:Math.round(day.r.c * M_TO_FT)
        };

        if (day.r.h) {
            day.r.m.p=[];
            for (var i=0;i<day.r.h.length;i++){
                day.r.m.p[i]=Math.round(day.r.h[i] * M_TO_FT);
            }
        }
    }

    const taskDistance = JSON.parse(day.k.description).d;
    const taskStartTime = day.a ? moment.utc(day.a).format('HH:mm') : 'Not set'
    const taskStartAltitude = day.h ? (heightFt ? day.r.m.h + " ft (" + day.h + " m)" : day.h + " m") : "No limit"
    const taskFinishAltitude = day.f ? (heightFt ? day.r.m.f + " ft (" + day.f + " m)" : day.f + " m") : "No limit"
    const taskMaxAltitude = day.r && day.r.c ? (heightFt ? day.r.m.c + " ft (" + day.r.c + " m)" : day.r.c + " m") : "No limit"
    const taskQnhSetting = day.r && day.r.qnh ? (day.r.qnh!==0 ? day.r.qnh + " hPa" : "Not set") : "Not set"
    const taskBonusPoint = day.r && day.r.x && day.k ? day.k.data.g[day.r.x].n : "No bonus"

    let desc="";
    let pts=day.k.data.g;
    for (let i=0; i<pts.length;i++) {
        desc+=(i>0 ? " - " : "")+pts[i].n;
    }

    const downloadHandicappedCupTask = (handicap) => {
        console.log(handicap)
    }

    return (
            <Box>
                <Box mb={2} sx={{display:'flex',alignItems:'center'}}>
                    <Typography variant={'h3'} flexGrow={1}>{day.t}</Typography>
                    {/*<Alert severity={'warning'} sx={{mr:'2em',py:0}}>THIS IS NOT THE CURRENTLY SET TASK</Alert>*/}
                    <Typography variant={'h3'}>Task: {day.k.name}</Typography>
                </Box>
                <Box sx={{bgcolor:'#f0f0f0',textAlign:'left'}} py={1} px={2}>
                    <Box sx={{display:'flex',alignItems:'center',columnGap:'1.5em',flexWrap:'wrap',justifyContent:'space-between'}}>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Start time:</span> {taskStartTime}</Typography>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Start altitude:</span> {taskStartAltitude}</Typography>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Finish altitude:</span> {taskFinishAltitude}</Typography>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Max Task Altitude:</span> {taskMaxAltitude}</Typography>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>QNH setting:</span> {taskQnhSetting}</Typography>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Bonus Point TP:</span> {taskBonusPoint}</Typography>
                    </Box>
                    <Box sx={{display:'flex',alignItems:'center',columnGap:'1.5em',flexWrap:'wrap',justifyContent:'space-between'}}>
                        <Typography variant={'body2'}><span style={{fontWeight:700}}>Distance:</span> {taskDistance}</Typography>
                        <Typography variant={'body2'} sx={{fontStyle:'italic',fontSize:'12px',mt:'4px'}}>{desc}</Typography>
                    </Box>
                </Box>
                <Grid2 container mt={'6px'}>
                    <Grid2 xs={12} md={rules?.handicapped && day.k.data.h ? 8: 9}>
                        <Map lat={day.k ? day.k.data.at.a : 0} lon={day.k ? day.k.data.at.o : 0} zoom={14} height={'640px'}>
                            <MapControls/>
                            <DayTaskRenderer day={day}/>
                        </Map>
                    </Grid2>
                    <Grid2 xs={12} md={rules?.handicapped && day.k.data.h ? 4 : 3} sx={{pl:{xs:'0px',md:'6px'}}}>
                        <Stack spacing={1}>
                            {day.k.data.g.map( (w,idx) =>{
                                if (rules?.handicapped && day.k.data.h) {
                                    //handicapped
                                    return (
                                        <Box sx={{display:'flex',alignItems:'stretch',columnGap:'6px'}}>
                                            <Box sx={{
                                                padding: '3px 6px',
                                                border: 'solid 1px grey',
                                                borderRadius: '4px',
                                                background: '#fafafa',
                                                fontSize: '.9rem',
                                                flex:1
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    justifyContent: 'space-between',
                                                    colGap: '1em'
                                                }}>
                                                    <Box sx={{
                                                        width: '60px',
                                                        fontWeight: 700
                                                    }}>{idx === 0 ? 'Start' : idx === day.k.data.g.length - 1 ? 'Finish' : 'TP ' + idx}</Box>
                                                    <Box>{w.n}</Box>
                                                    <Box sx={{fontSize: '7pt', textAlign: 'right'}}>
                                                        <div
                                                            dangerouslySetInnerHTML={{__html: CCI.Util.toCoords(w.a, w.o, "<br/>") + (w.w && w.w.alt !== 0 ? "<br/>" + CCI.Util.toUnitString(w.w.alt, CCI.unit.type.alt, undefined, undefined, rules.altUnits) : '')}}/>
                                                    </Box>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    justifyContent: 'space-between'
                                                }}>
                                                    <Box>{idx === 0 ? 'Line: length ' + (w.r ? (w.r / 1000 * 2) : '5') + ' km' : idx === day.k.data.g.length - 1 ? 'Line: length ' + (w.r ? (w.r / 1000 * 2) : '0.5') + ' km' : 'Cylinder' + (w.r && w.r !== 500 ? ' <b>r=' + (w.r / 1000) + ' km</b>' : w.r ? ' r=' + (w.r / 1000) + ' km' : '')}</Box>
                                                    <Box>{idx === 0 ? (day.h ? "Max alt: " + (heightFt ? day.r.m.h + ' ft' : day.h + " m") : " ") : idx === day.k.data.g.length - 1 ? (day.f ? "Min alt: " + (heightFt ? day.r.m.f + ' ft' : day.f + " m") : " ") : " "}</Box>
                                                    <Box>{idx === 0 ? " " : Math.round(L.latLng(day.k.data.g[idx - 1].a, day.k.data.g[idx - 1].o).distanceTo([w.a, w.o]) / 1000) + ' km'}</Box>
                                                    <Box>{idx === 0 ? " " : Math.round(Util.calcBearing(L.latLng(day.k.data.g[idx - 1].a, day.k.data.g[idx - 1].o), L.latLng(w.a, w.o))) + "°"}</Box>
                                                </Box>
                                                {idx !== 0 && idx !== day.k.data.g.length - 1 &&
                                                    <Box>
                                                        {day.r.h && day.r.h[idx - 1] ? '<b>Max alt:</b>  ' + (day.r.h && day.r.h[idx - 1] ? (heightFt ? day.r.m.p[idx - 1] + ' ft' : day.r.h[idx - 1] + " m") : 'No limit') : ''}
                                                    </Box>
                                                }
                                            </Box>
                                            {rules.handicapSetup.handicaps.toReversed().map(h=>{
                                                const radii=day.k.data.h[h]

                                                return (
                                                    <>
                                                        {idx===0 ?
                                                            <Box sx={{
                                                                padding: '3px 6px',
                                                                border: 'solid 1px grey',
                                                                borderRadius: '4px',
                                                                fontSize:'.9rem',
                                                                width:'5em',
                                                                background:'#dddddd',
                                                                display:'flex',
                                                                flexDirection:'column',
                                                                alignItems:'center',
                                                                justifyContent:'center',
                                                            }}>
                                                                <Box>Group</Box>
                                                                <Box>{rules.handicapSetup.handicapLabels[h]}</Box>
                                                            </Box>
                                                            :
                                                            idx < day.k.data.g.length-2 ?
                                                                <Box sx={{
                                                                    padding: '3px 6px',
                                                                    border: 'solid 1px grey',
                                                                    borderRadius: '4px',
                                                                    fontSize:'.9rem',
                                                                    width:'5em',
                                                                    display:'flex',
                                                                    flexDirection:'column',
                                                                    alignItems:'center',
                                                                    justifyContent:'center',
                                                                }}>
                                                                    <Box>Radius</Box>
                                                                    <Box>{radii ? (radii[idx-1]/1000.0).toFixed(1) : '0.5'} km</Box>
                                                                </Box>
                                                                :
                                                                idx === day.k.data.g.length-2 ?
                                                                    <Box sx={{
                                                                        padding: '3px 6px',
                                                                        border: 'solid 1px grey',
                                                                        borderRadius: '4px',
                                                                        fontSize:'.9rem',
                                                                        width:'5em',
                                                                        display:'flex',
                                                                        flexDirection:'column',
                                                                        alignItems:'center',
                                                                        justifyContent:'center',
                                                                    }}>
                                                                        <Box>Radius</Box>
                                                                        <Box>0.5 km</Box>
                                                                    </Box>
                                                                    :
                                                                    false ?
                                                                    <Box sx={{
                                                                        padding: '3px 6px',
                                                                        border: 'solid 1px grey',
                                                                        borderRadius: '4px',
                                                                        fontSize:'.9rem',
                                                                        width:'5em',
                                                                        display:'flex',
                                                                        flexDirection:'column',
                                                                        alignItems:'center',
                                                                        justifyContent:'center',
                                                                        background:'#dddddd',
                                                                        cursor:'pointer',
                                                                    }}
                                                                         onClick={()=>{downloadHandicappedCupTask(h)}}
                                                                    >
                                                                        <Box>CUP file</Box>
                                                                        <Box><Download size={'small'}/></Box>
                                                                    </Box>
                                                                        :
                                                                        <Box></Box>
                                                        }
                                                    </>)
                                            })}

                                        </Box>
                                    )
                                }
                                else {
                                    return (
                                        <Box sx={{
                                            padding: '3px 6px',
                                            border: 'solid 1px grey',
                                            borderRadius: '4px',
                                            background: '#fafafa',
                                            fontSize: '.9rem'
                                        }}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                justifyContent: 'space-between',
                                                colGap: '1em'
                                            }}>
                                                <Box sx={{
                                                    width: '60px',
                                                    fontWeight: 700
                                                }}>{idx === 0 ? 'Start' : idx === day.k.data.g.length - 1 ? 'Finish' : 'TP ' + idx}</Box>
                                                <Box>{w.n}</Box>
                                                <Box sx={{fontSize: '7pt', textAlign: 'right'}}>
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: CCI.Util.toCoords(w.a, w.o, "<br/>") + (w.w && w.w.alt !== 0 ? "<br/>" + CCI.Util.toUnitString(w.w.alt, CCI.unit.type.alt, undefined, undefined, rules.altUnits) : '')}}/>
                                                </Box>
                                            </Box>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                justifyContent: 'space-between'
                                            }}>
                                                <Box>{idx === 0 ? 'Line: length ' + (w.r ? (w.r / 1000 * 2) : '5') + ' km' : idx === day.k.data.g.length - 1 ? 'Line: length ' + (w.r ? (w.r / 1000 * 2) : '0.5') + ' km' : 'Cylinder' + (w.r && w.r !== 500 ? ' <b>r=' + (w.r / 1000) + ' km</b>' : w.r ? ' r=' + (w.r / 1000) + ' km' : '')}</Box>
                                                <Box>{idx === 0 ? (day.h ? "Max alt: " + (heightFt ? day.r.m.h + ' ft' : day.h + " m") : " ") : idx === day.k.data.g.length - 1 ? (day.f ? "Min alt: " + (heightFt ? day.r.m.f + ' ft' : day.f + " m") : " ") : " "}</Box>
                                                <Box>{idx === 0 ? " " : Math.round(L.latLng(day.k.data.g[idx - 1].a, day.k.data.g[idx - 1].o).distanceTo([w.a, w.o]) / 1000) + ' km'}</Box>
                                                <Box>{idx === 0 ? " " : Math.round(Util.calcBearing(L.latLng(day.k.data.g[idx - 1].a, day.k.data.g[idx - 1].o), L.latLng(w.a, w.o))) + "°"}</Box>
                                            </Box>
                                            {idx !== 0 && idx !== day.k.data.g.length - 1 &&
                                                <Box>
                                                    {day.r.h && day.r.h[idx - 1] ? '<b>Max alt:</b>  ' + (day.r.h && day.r.h[idx - 1] ? (heightFt ? day.r.m.p[idx - 1] + ' ft' : day.r.h[idx - 1] + " m") : 'No limit') : ''}
                                                </Box>
                                            }
                                        </Box>
                                    )
                                }
                                })
                            }
                        </Stack>
                    </Grid2>
                </Grid2>
            </Box>
    )
}

/*
            function drawAirspace() {
                CC.ui.taskMap.airspaceMgr.options.renderCallback=function(){
                    if (CC.g.rules && CC.g.rules.activeAirspaceDetails==1) describeAirspace();
                };
                CC.ui.taskMap.airspaceMgr.selectList(day.r && day.r.a ? day.r.a :0);
            }

            function describeAirspace(){
                if (day.r && day.r.a) {
                    var notes=$id('tasksheetNotes');


                    var blocks=CC.ui.taskMap.airspaceMgr.list.blocks;

                    var txt="";

                    for (var i=0;i<blocks.length;i++) {
                        txt+=blocks[i].t+", ";
                    }

                    if (txt.length>0) {
                        txt=txt.substr(0,txt.length-2);
                        notes.innerHTML="<b>Notes:</b> Active airspace: "+txt;
                    }
                }
            }
 */

export default DayTaskDetails;